import { NAV_BRAND, TRACKING_GLOBALS } from '@/config'
import { api } from '@/services'
import { captureException } from '@/utils/asyncSentry'

import { PORTAL_TYPE_RJA } from '../../config/constants'
import { getAbsoluteUrl } from '../../utils/url'

import { isKalaydo, isSta, isGeneric } from './detatched'
import initPJA from './pja'

initPJA()

/**
 * @param {String} eventName - name of the event to track
 * @param {Number|String} id - id of the job/company that is tracked
 * @param {String} type - the object type we are tracking - defaults to 'job', could also be
 *     'company'
 * */

const getJobTrackingParams = (params) => {
  const pjaParams = {}
  if (NAV_BRAND.portal_type === PORTAL_TYPE_RJA) {
    const trackUrl = new URL(getAbsoluteUrl(params.jobUrl))
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (trackUrl.searchParams.has(key)) {
        trackUrl.searchParams.set(key, value)
      } else {
        trackUrl.searchParams.append(key, value)
      }
    })
    pjaParams.isEntry = TRACKING_GLOBALS.isPjaEntry
    pjaParams.trackUrl = trackUrl.toString()
    if (TRACKING_GLOBALS.isPjaEntry) {
      TRACKING_GLOBALS.isPjaEntry = false
    }
  }
  return {
    fromSta: isSta(),
    fromKalaydo: isKalaydo(),
    fromGeneric: isGeneric(),
    ...pjaParams
  }
}

export default function trackInternalEvent (eventName, id, type = 'job', params = {}) {
  let call
  switch (type) {
    case 'company':
      call = api.trackInternalCompanyEvent(eventName, id)
      break
    case 'job':
      call = api.trackInternalJobEvent(eventName, id, getJobTrackingParams(params))
      break
    default:
      throw new Error(`Unknown internal event type ${type} for event ${eventName}`)
  }

  call.catch((reason) => {
    // log only client side errors
    if (reason.response.status >= 400 && reason.response.status < 500) {
      captureException(reason)
    }
  })
}
